const VISITOR_ID_KEY = 'rs-visitor-id';
const SESSION_ID_KEY = 'rs-session-id';

function readOrCreate(storage: Storage, key: string): string {
  try {
    const existing = storage.getItem(key);
    if (existing) return existing;
    const created = crypto.randomUUID();
    storage.setItem(key, created);
    return created;
  } catch {
    // Sin almacenamiento disponible (modo privado, cuotas, etc.): un id que
    // no persiste es preferible a que el tracker rompa la navegación.
    return crypto.randomUUID();
  }
}

/** Id anónimo persistente del navegador. Sobrevive a cerrar y reabrir el sitio. */
export function getVisitorId(): string {
  return readOrCreate(localStorage, VISITOR_ID_KEY);
}

/** Id de la visita actual. Se resetea por pestaña/sesión de navegador. */
export function getSessionId(): string {
  return readOrCreate(sessionStorage, SESSION_ID_KEY);
}
